import { render, staticRenderFns } from "./CulturaManage.vue?vue&type=template&id=7e65668a&scoped=true"
import script from "./CulturaManage.vue?vue&type=script&lang=js"
export * from "./CulturaManage.vue?vue&type=script&lang=js"
import style0 from "./CulturaManage.vue?vue&type=style&index=0&id=7e65668a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65668a",
  null
  
)

export default component.exports